import 'vanilla-cookieconsent/dist/cookieconsent.css'
import * as CookieConsent from 'vanilla-cookieconsent'

// run plugin with your configuration
CookieConsent.run({
    autoClearCookies: true,
    disablePageInteraction: true,
    revision: 1,
    autoShow: !document
        .querySelector('body')
        .classList.contains('hide-consent'), // default: true
    guiOptions: {
        consentModal: {
            layout: 'box', // box/cloud/bar
            position: 'middle center', // bottom/middle/top + left/right/center,
            equalWeightButtons: false
        },
        preferencesModal: {
            equalWeightButtons: false
        }
    },
    onConsent: ({ cookie }) => {
        if (CookieConsent.acceptedCategory('analytics')) {
            fbq('consent', 'grant')
        } else {
            fbq('consent', 'revoke')
        }
    },

    onChange: ({ cookie, changedCategories, changedPreferences }) => {
        if (CookieConsent.acceptedCategory('analytics')) {
            fbq('consent', 'grant')
        } else {
            fbq('consent', 'revoke')
        }
    },
    categories: {
        necessary: {
            readOnly: true
        },
        analytics: {
            readOnly: false,
            enabled: false,
            autoClear: {
                reloadPage: true,
                cookies: [
                    {
                        name: /^(_ga)/ //regex
                    },
                    {
                        name: '_gid' //string
                    }
                ]
            }
        }
    },
    language: {
        default: 'nl-BE',
        translations: {
            'nl-BE': {
                consentModal: {
                    title: 'Deze website maakt gebruik van cookies.',
                    description:
                        'Deze website gebruikt cookies om uw gebruikerservaring te verbeteren. Door onze website te gebruiken, stemt u in met alle cookies in overeenstemming met ons <a href="/cookie-policy">cookiebeleid</a>.',
                    acceptAllBtn: 'Aanvaard alle cookies',
                    showPreferencesBtn: 'Instellingen'
                },
                preferencesModal: {
                    title: 'Cookie voorkeuren',
                    acceptAllBtn: 'Aanvaard alle cookies',
                    acceptNecessaryBtn: 'Alle cookies afwijzen',
                    savePreferencesBtn: 'Keuze opslaan',
                    closeIconLabel: 'Sluiten',
                    sections: [
                        {
                            title: 'Cookie verklaring',
                            description:
                                'Cookies zijn kleine tekstbestanden die op uw computer worden geplaatst door websites die u bezoekt. Websites gebruiken cookies om gebruikers te helpen efficiënt te navigeren en om bepaalde functies uit te voeren. Cookies die nodig zijn om de website goed te laten functioneren, mogen zonder uw toestemming worden geplaatst. Alle andere cookies moeten worden goedgekeurd voordat ze in de browser kunnen worden ingesteld. U kunt uw toestemming voor het gebruik van cookies op elk moment wijzigen op onze pagina <a href="/cookie-policy">cookiebeleid.</a>'
                        },
                        {
                            title: 'Strikt noodzakelijke cookies',
                            description:
                                'Deze cookies zijn essentieel voor het goed functioneren van de website. Zonder deze cookies zou de website niet goed werken.',
                            linkedCategory: 'necessary'
                        },
                        {
                            title: 'Analytische cookies',
                            description:
                                'Deze cookies verzamelen informatie over hoe u onze website gebruikt. Alle gegevens worden geanonimiseerd en kunnen niet worden gebruikt om u te identificeren.',
                            linkedCategory: 'analytics'
                        }
                    ]
                }
            }
        }
    }
})
